var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSpan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 4,
    fill: "#D4EEF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 26V25.9167C31 24.8581 30.1419 24 29.0833 24H27C25.8954 24 25 24.8954 25 26C25 27.1046 25.8954 28 27 28H29C30.1046 28 31 28.8954 31 30C31 31.1046 30.1046 32 29 32H26.9583C25.8768 32 25 31.1232 25 30.0417V30M28 33.5V22.5M37 28C37 32.9706 32.9706 37 28 37C23.0294 37 19 32.9706 19 28C19 23.0294 23.0294 19 28 19C32.9706 19 37 23.0294 37 28Z",
    stroke: "#19292F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSpan);
export default __webpack_public_path__ + "static/media/dollar-span.21302c2103dde63d702bc0e8a086cffa.svg";
export { ForwardRef as ReactComponent };